<template>
<!--
  The body of a Prepr product page: introduction, details and the tabbed sections.

  Lifted from BloodDetails so the store's product page for a Health Report shows the same
  content as the page the genetics results link to. The store page used to adapt the
  Prepr product to Craft's shape, and everything Craft has no field for - introduction,
  tabs, how it works, FAQs, testimonials - was left out.
-->
  <!-- content row starts here -->
  <div class="details-content-row">
    <h4>Explore Your {{ product.product_name }} </h4>
    <span v-html="product.product_introduction"></span>

    <h4>{{ product.product_detail_header }}</h4>
    <div v-html="product.product_details"></div>
  </div>
  <!-- content row ends here -->

  <!-- Tab Module content row starts here -->
  <div class="tab-container">
    <div class="tab-module-wrapper-blood-details-row">
      <div
        v-for="(tab, index) in product.product_page_tabs"
        :key="index"
        @click="selectTab(index)"
        :class="{ 'active-tab': selectedTab === index }"
        class="tab-module"
        :style="{
          backgroundColor: selectedTab === index ? '#3377FF' : '#E6E6E6',
        }"
      >
        <p
          class="mt-1 mb-0"
          :style="{
            color: selectedTab === index ? 'white' : '#A7A7A7',
            fontWeight: selectedTab === index ? 600 : 500,
          }"
        >
          {{ tab.name }}
        </p>
      </div>
    </div>
  </div>
  <!-- Tab Module content row ends here -->

  <!-- Container For Tab Module -->
  <div class="container-selected-tabs my-4" v-for="(tab, index) in product.product_page_tabs"
  :key="index">
    <div v-if="selectedTab === index">
      <!-- row starts here -->
      <div class="row">
        <div
          class="col-lg-7 col-md-6 d-flex flex-column align-items-center justify-content-center"
        >
          <div class="content-selected-row">
            <img class="mb-3"  v-if="tab.icon" :src="tab?.icon[0]?.url" alt="" />
            <span v-html="tab.body"></span>
          </div>
        </div>
        <div
          class="col-lg-5 col-md-6 d-flex flex-column align-items-center justify-content-center"
        >
          <div class="selected-tab-image" v-if="tab.image">
            <img :src="tab?.image[0]?.url" alt="" />
          </div>
        </div>
      </div>
      <!-- row ends here -->
    </div>
  </div>
  <!-- Container For Tab Module -->
</template>

<script setup>
import { ref, defineProps } from "vue";
import "@/styles/pages/BloodTestDetails.scss";

defineProps({
  // A Prepr ProductPage, as getProductData returns it.
  product: { type: Object, required: true },
});

const selectedTab = ref(0);

const selectTab = (index) => {
  selectedTab.value = index;
};
</script>
